import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function HotArticles() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3 whitespace-nowrap">
              热门吃瓜
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              最新热门爆料
            </h2>
          </div>
          <Link
            to="/category/dujia-heiliao"
            className="hidden sm:flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {hotArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/dujia-heiliao"
            className="inline-flex items-center gap-1 px-5 py-2.5 border border-foreground-200 rounded-full text-sm text-foreground-600 hover:border-primary-500 hover:text-primary-500 transition-all cursor-pointer whitespace-nowrap"
          >
            查看全部爆料
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}